export function slug(value: string): string {
  if (!value) return "";
  // Replace any character that is not an ASCII letter or number with an underscore.
  // Using A-Za-z0-9 keeps this compatible with older TypeScript/ES targets.
  // Then collapse consecutive underscores into a single underscore and
  // trim leading/trailing underscores.
  const replaced = value.replace(/[^A-Za-z0-9]+/g, "_");
  const collapsed = replaced.replace(/_+/g, "_");
  return collapsed.replace(/^_+|_+$/g, "").toLowerCase();
}
